export const setRankText = {
  0: '',
  1: '',
  2: '氾濫注意水位',
  3: '避難判断水位',
  4: '氾濫危険水位',
  5: '計画高水位'
}

export const setRankDetailText = {
  0: '',
  1: '',
  2: '氾濫注意水位（警戒レベル2相当）',
  3: '避難判断水位（警戒レベル3相当）',
  4: '氾濫危険水位（警戒レベル4相当）',
  5: '計画高水位（警戒レベル5相当）'
}

export const prefectures = [
  '北海道',
  '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
  '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
  '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県',
  '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
  '鳥取県', '島根県', '岡山県', '広島県', '山口県',
  '徳島県', '香川県', '愛媛県', '高知県',
  '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
]

export const prefectureList = [
  { name: '都道府県', key: 'none' },
  { name: '北海道', key: 'hokkaido' },
  { name: '青森県', key: 'aomori' },
  { name: '岩手県', key: 'iwate' },
  { name: '秋田県', key: 'akita' },
  { name: '宮城県', key: 'miyagi' },
  { name: '山形県', key: 'yamagata' },
  { name: '福島県', key: 'fukushima' },
  { name: '茨城県', key: 'ibaraki' },
  { name: '栃木県', key: 'tochigi' },
  { name: '群馬県', key: 'gunma' },
  { name: '埼玉県', key: 'saitama' },
  { name: '千葉県', key: 'chiba' },
  { name: '東京都', key: 'tokyo' },
  { name: '神奈川県', key: 'kanagawa' },
  { name: '新潟県', key: 'niigata' },
  { name: '富山県', key: 'toyama' },
  { name: '石川県', key: 'ishikawa' },
  { name: '福井県', key: 'fukui' },
  { name: '山梨県', key: 'yamanashi' },
  { name: '長野県', key: 'nagano' },
  { name: '岐阜県', key: 'gifu' },
  { name: '静岡県', key: 'shizuoka' },
  { name: '愛知県', key: 'aichi' },
  { name: '三重県', key: 'mie' },
  { name: '滋賀県', key: 'shiga' },
  { name: '京都府', key: 'kyoto' },
  { name: '大阪府', key: 'osaka' },
  { name: '兵庫県', key: 'hyogo' },
  { name: '奈良県', key: 'nara' },
  { name: '和歌山県', key: 'wakayama' },
  { name: '鳥取県', key: 'tottori' },
  { name: '島根県', key: 'shimane' },
  { name: '岡山県', key: 'okayama' },
  { name: '広島県', key: 'hiroshima' },
  { name: '山口県', key: 'yamaguchi' },
  { name: '徳島県', key: 'tokushima' },
  { name: '香川県', key: 'kagawa' },
  { name: '愛媛県', key: 'ehime' },
  { name: '高知県', key: 'kouchi' },
  { name: '福岡県', key: 'fukuoka' },
  { name: '佐賀県', key: 'saga' },
  { name: '長崎県', key: 'nagasaki' },
  { name: '熊本県', key: 'kumamoto' },
  { name: '大分県', key: 'oita' },
  { name: '宮崎県', key: 'miyazaki' },
  { name: '鹿児島県', key: 'kagoshima' },
  { name: '沖縄県', key: 'okinawa' }
]
